<template>
    <div>
        <div class="section section_awards">
            <div class="bk_award-block" data-aos="fade-up" data-aos-duration="2000" data-aos-offset="400"></div>
            <h2 class="section__title grey--text" data-aos="fade-up">{{ model.menu_title }}</h2>
            <v-layout class="mt-5 row_awards" row wrap>
                <v-flex v-for="(item, i) in model.items"
                        :key="i"
                        @click="itemClicked(item)"
                        :class="item.is_full === 'full' ? 'doc full' : 'doc'">
                    <img class="img_test" :src="$apiHost + item.cover" alt="awards" data-aos="fade-up">
                    <div class="doc__title" data-aos="fade-up">{{ item.title }}</div>
                    <div class="doc__subtitle" data-aos="fade-up">{{ item.description }}</div>
                </v-flex>
            </v-layout>
        </div>
        <transition name="modal">
            <div class="modal"
                 v-if="modalDoc">
                <button
                        @click="modalDoc = false" class="btn-menu active black--text"
                ></button>
                <div class="modal__window" v-bind:class="{full: isFull}">
                    <div>
                        <img :src="image" v-bind:class="{blur: isEn && article !== null && article.length > 0}">
                        <a class="link_pdf white--text" :href="linkPdf" target="_blank">{{ seePdf }}</a>
                    </div>

                </div>

                <transition :duration="{ enter: 500, leave: 800 }">
                    <div class="modal__info" v-if="isEn && article !== null && article.length > 0">
                        <div v-html="article"></div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['model'],
        data() {
            return {
                modalDoc: false,
                image: null,
                isFull: false,
                article: null,
                linkPdf: '',
            }
        },
        methods: {
            itemClicked: function (item) {
                this.image = this.$apiHost +  item.cover;
                this.isFull = false;
                this.isFull = item.is_full === 'full'
                this.article = item.cover_description;
                this.linkPdf = item.pdf !== null ? this.$apiHost + item.pdf : null;
                this.modalDoc = true;
            },
        },
        computed: {
            docs() {
                return this.$store.getters.docs
            },
            seePdf() {
                if (!this.$route.params.lang) {
                    return 'смотреть PDF'
                } else if (this.$route.params.lang === 'fr') {
                    return 'voir le PDF'
                } else {
                    return 'view PDF'
                }
            },
            isEn () {
                if (!this.$route.params.lang) {
                    return false
                } else {
                    return true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .section_awards {
        height: auto;
        font-family: "CirceRegular", sans-serif;
    }

    /* стили сетки */

    .row_awards {
        z-index: 9;
    }

    .doc {
        text-align: left;
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        transition: .7s !important;
        cursor: pointer;
        z-index: 9;
        flex-basis: 23%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 23%;
        margin-left: 16.666666666666664%;
        @media screen and (max-width: 600px) {
            flex-basis: 66.66666666666666%;
            -ms-flex-positive: 0;
            flex-grow: 0;
            max-width: 66.66666666666666%;
        }
    }

    .doc.full {
        margin-left: 16.666666666666664%;
        flex-basis: 42.5%;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 42.5%;
    }

    .doc img {
        width: 100%;
        margin: 40px auto;
    }

    .doc__title {
        font-size: 22px;
        font-family: "CirceRegular", sans-serif;

    }

    .doc__subtitle {
        font-size: 16px;

    }

    .doc:hover {
        -webkit-filter: grayscale(0%);
        -moz-filter: grayscale(0%);
        -o-filter: grayscale(0%);
        filter: grayscale(0%);
    }

    /* стили модального окна и его анимации */

    .modal {
        position: fixed;
        z-index: 99999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(115, 115, 115, 0.89);
        border: 2px rgba(0, 0, 0, 0.25);
        transition: all .3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 1024px) {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
        }
    }

    .modal_full {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .modal__window {
        transition: all .3s ease;
        width: 100%;
        background-color: transparent;
        color: black;
        max-height: 90%;
        overflow-y: auto;
        text-align: center;
    }

    .modal__info {
        position: fixed;
        width: 500px;
        height: 80vh;
        max-height: 80vh;
        background-color: #fff;
        border: 2px solid #000;
        overflow-y: scroll;
        padding: 20px;
        box-sizing: border-box;
        right: 10%;
        @media screen and (max-width: 1024px) {
            width: 90%;
            right: 0;
        }
    }

    .modal img {
        @media screen and (max-width: 610px) {
            width: 100%;
        }
    }

    .blur {
        -webkit-filter: blur(2px);
        filter: blur(2px);
    }

    .close_modal {
        position: absolute;
        top: 20px;
        right: 55px;
        outline: none;
        z-index: 99999;
        cursor: pointer;
        width: 100px;
        height: 100px;
        opacity: .66;
        transition: .3s;
    }

    .close_modal img {
        width: 100px;
        height: 100px;
    }

    .close_modal:hover {
        opacity: .9;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal__window,
    .modal-leave-active .modal__window {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* стили 'background-а' */

    .bk_award-block {
        z-index: 0;
        width: 70%;
        position: absolute;
        display: block;
        left: 0;
        top: 160px;
        height: 120%;
        background: url('../../assets/img/MA_1920_beton4.png');
        background-position: right;
        background-repeat: no-repeat;
    }

    .link_pdf {
        margin-top: 20px;
        display: block;
        text-decoration: none;
        opacity: .8;
        transition: .3s;
    }

    .link_pdf:hover {
        opacity: 1;
    }

</style>



// WEBPACK FOOTER //
// src/components/home-page-components/AwardsBlock.vue